module.exports = __webpack_public_path__ + "img/close_btn.53a7604d.svg";